<template>
  <div v-if="coords.length >= 2" class="mt" :title="`Tendencia ${signo}${delta}`">
    <svg :width="W" :height="H" class="mt-svg">
      <polygon :fill="relleno" :points="areaPoints" />
      <polyline
        fill="none"
        :stroke="trazo"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        :points="linePoints"
      />
      <circle
        v-for="(c, i) in coords"
        :key="i"
        :cx="c.x"
        :cy="c.y"
        :r="i === coords.length - 1 ? 2.5 : 1.5"
        :fill="trazo"
        class="mt-dot"
      />
    </svg>
    <span class="mt-delta" :class="subiendo ? 'up' : 'down'">
      {{ signo }}{{ delta }}
    </span>
  </div>
  <span v-else class="mt-nd">—</span>
</template>

<script>
export default {
  name: "MiniTrend",

  props: {
    // Scores por año; los nulos se omiten (no son ceros).
    valores: { type: Array, default: () => [] },
  },

  data() {
    return { W: 72, H: 26, padY: 2 };
  },

  computed: {
    validos() {
      return this.valores.filter((v) => v != null && !Number.isNaN(v));
    },

    coords() {
      const v = this.validos;
      if (v.length < 2) return [];
      // Escala propia por fila: el sparkline comunica la FORMA de la
      // tendencia. Los valores absolutos ya están en las columnas de año.
      const min = Math.min(...v) - 1;
      const max = Math.max(...v) + 1;
      const rango = max - min || 1;
      const alto = this.H - this.padY * 2;

      return v.map((valor, i) => ({
        x: (i / (v.length - 1)) * this.W,
        y: this.padY + alto - ((valor - min) / rango) * alto,
      }));
    },

    linePoints() {
      return this.coords.map((c) => `${c.x},${c.y}`).join(" ");
    },

    areaPoints() {
      return `0,${this.H} ${this.linePoints} ${this.W},${this.H}`;
    },

    variacion() {
      const v = this.validos;
      return v.length >= 2 ? v[v.length - 1] - v[0] : 0;
    },

    subiendo() {
      return this.variacion >= 0;
    },

    signo() {
      return this.subiendo ? "+" : "";
    },

    delta() {
      return this.variacion.toFixed(1);
    },

    trazo() {
      return this.subiendo ? "#43B234" : "#FF5D73";
    },

    relleno() {
      return this.subiendo ? "rgba(67,178,52,0.15)" : "rgba(255,93,115,0.12)";
    },
  },
};
</script>

<style scoped>
.mt {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mt-svg {
  overflow: visible;
  flex-shrink: 0;
}

.mt-dot {
  stroke: var(--white);
  stroke-width: 1;
}

.mt-delta {
  font-size: 11.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.mt-delta.up {
  color: var(--verde);
}
.mt-delta.down {
  color: var(--rojo);
}

.mt-nd {
  color: var(--txt-faint);
  font-size: 12px;
}
</style>
